import { render, staticRenderFns } from "./ShareTop.vue?vue&type=template&id=d4be1e32&scoped=true&"
import script from "./ShareTop.vue?vue&type=script&lang=js&"
export * from "./ShareTop.vue?vue&type=script&lang=js&"
import style0 from "./ShareTop.vue?vue&type=style&index=0&id=d4be1e32&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4be1e32",
  null
  
)

export default component.exports